import styled from "styled-components";

export const ScrollableContent = styled.div`
    height: 100vh;
    overflow-y: auto;
    padding: 0 16px 16px;
`;

export const MobileGrid = styled.div<{ columns?: number }>`
    display: grid;
    grid-template-columns: repeat(${({ columns }) => columns || 2}, 1fr);
    gap: 12px;
    margin-top: 16px;
`;

export const MobileCardWrapper = styled.div`
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    background: ${({ theme }) => theme.mobileCardBg};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const ThumbnailWrapper = styled.div`
    line-height: 0;
    aspect-ratio: 16 / 9;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const CardTitle = styled.div`
    font-weight: 700;
    font-size: 14px;
    padding: 6px 8px 8px;
    margin: 0;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
    color: ${({ theme }) => theme.mobileCardTitleColor};
`;

export const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 16px 8px;
    justify-content: space-between;
`;

export const BackArrow = styled.span`
    cursor: pointer;
    display: flex;
    align-items: center;
`;

export const TitleContainer = styled.span`
    font-weight: 700;
    font-size: 18px;
    color: ${({ theme }) => theme.modalColor};
`;

export const VideoCount = styled.span`
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.modalSubText};
    margin-left: 8px;
`;
